import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const dutyLocaleModule: LocaleModule = {
  name: "duty",
  messages: { en: en, it: it },
};
